<template>
  <div class="single-social-network-link">
    <div class="left">
      <img :src="iconImg" id="network-input" />
      {{ networkName }}
    </div>
    <div class="right">
      <a-input :maxLength="255" :addon-before="FOOTER_URL_PREFIX" placeholder="Input URL" :value="strippedUrl" @input="$emit('socialNetwork',{
        networkName,
        url: FOOTER_URL_PREFIX + $event.target.value
      })"/>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  props: {
    networkName: {
      type: String,
    },
    iconImg: {
      type: String,
    },
    url: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState(['FOOTER_URL_PREFIX']),
    strippedUrl () {
      return this.url.includes(this.FOOTER_URL_PREFIX)? this.url.slice(this.FOOTER_URL_PREFIX.length) : this.url;
    },
  },
};
</script>

<style scoped lang='scss'>
.single-social-network-link {
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .left {
    display: flex;
    align-items: center;
    justify-content: center;
    img{
        display: block;
        margin: 0 10px 0 0;
    }
  }
  .right {
    width: 470px;
  }
}
</style>

<style>
/* utility selector for the ant input */
body
  > div
  > div
  > div.footer.admin-page
  > div.content-wrap
  > div.social-media-links
  > div
  > div.links-wrapper
  > div
  > div.right
  > input {
  width: 470px;
  height: 40px;
  background: #ffffff;
  border: 1px solid #dfe1e6;
  box-sizing: border-box;
  border-radius: 2px;
}
</style>